var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-grid-vue',{ref:"agGrid",class:_vm.grid.theme,staticStyle:{"width":"100%","height":"100%"},attrs:{"grid-options":_vm.gridOptions,"column-defs":_vm.gridColumns,"row-data":_vm.gridData,"default-col-def":{
    sortable: true,
    resizable: true,
    minWidth: 100,
  },"group-headers":true,"suppress-row-click-selection":false,"suppress-scroll-on-new-data":true,"enable-cell-change-flash":false,"overlay-no-rows-template":_vm.gridOverlay},on:{"grid-ready":_vm.onGridReady,"pagination-changed":_vm.checkPagination}})}
var staticRenderFns = []

export { render, staticRenderFns }